import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Link, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";


const Header = (props) => {
  const [impersonateEmail, setImpersonateEmail] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const fetchStatus = async () => {
    try {
      const res = await fetch('/api/admin/status', { credentials: 'include' });
      if (!res.ok) return;
      const data = await res.json();
      setImpersonateEmail(data && data.impersonateEmail ? data.impersonateEmail : null);
    } catch (_) {
      // ignore
    }
  };

  // On mount
  useEffect(() => {
    fetchStatus();
    const onFocus = () => fetchStatus();
    const onCustom = () => fetchStatus();
    window.addEventListener('focus', onFocus);
    window.addEventListener('impersonation-changed', onCustom);
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('impersonation-changed', onCustom);
    };
  }, []);

  // On route change
  useEffect(() => {
    fetchStatus();
  }, [location.pathname]);

  const handleStopImpersonate = async () => {
    try {
      const res = await fetch('/api/admin/stop-impersonate', { method: 'POST', credentials: 'include' });
      if (res.ok) {
        setImpersonateEmail(null);
      }
      navigate("/adminManage");
    } catch (_) {
      // ignore
    }
  };

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src="/iXiVERSE-NEON-100.png"
                    alt="logo-sm-dark"
                    height="50"
                    width="50"
                  />
                </span>
                <span className="logo-lg">
                  <img src="/iXiVERSE-NEON-100.png"
                    alt="logo-dark"
                    height="100"
                    width="100"
                  />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src="/iXiVERSE-NEON-100.png"
                    alt="logo-sm-light"
                    height="50"
                    width="50"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="/iXiVERSE-NEON-100.png"
                    alt="logo-light"
                    height="100"
                    width="100"
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle();
              }}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
          </div>
          {impersonateEmail && (
            <div className="ms-3 align-self-center">
              <span className="badge rounded-pill badge-soft-warning fw-normal me-2">
                Filtre de compte actuel : <b>{impersonateEmail}</b>
              </span>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleStopImpersonate}
              >
                Quitter le filtre
              </button>
            </div>
          )}
          <div className="d-flex">



            <ProfileMenu />

            <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >

            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
